import { onError } from '@apollo/client/link/error';
import { Logger } from '@/helpers/log';
const logger = new Logger('api:apollo');
const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
            logger.error({ msg: 'graphql execution failed', error });
        });
    }
    if (networkError) {
        logger.error({ msg: 'graphql network error', error: networkError });
    }
});
export default errorLink;
